import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import TextField from '@mui/material/TextField';
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import { errorAlert } from '../../Components/Alerts';
import Autocomplete from "@mui/material/Autocomplete";
import ClientDetails from './Details/ClientsDetails';
import '../../Style/Kartela.scss';

export default function KartelaKlientit(props) {
    const headers = authHeader();

    const [clients, setClients] = useState([]);
    const [clientID, setClientid] = useState(0)
    const [nui, setNUI] = useState("");

    const [openDetails, setOpenDetails] = useState(false); // Deklarimi i useState


    const [accField, setAccfield] = useState(null)
    const [accName, setAccName] = useState(null)

    const handleAutocompleteChangeClient = (event, value) => {
        if (value && value.AccountID) {
            setClientid(value.AccountID);
            setAccfield(value);
            setAccName(value.AccountName);
            setNUI(value.IdentificationNumber);
        } else {
            // Në rast se vlera është pastruar
            setClientid(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsClients = {
        options: clients,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                </li>
            </>
        ),
    };

    const showCard = () => {
        if (clientID != 0) {
            setOpenDetails(true);
        }
        else {
            setOpenDetails(false);
            errorAlert("Ju lutem zgjedhni klientin")
        }
    }

    const fetchClients = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 105 } });
            setClients(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        fetchClients();
    }, [])

    return (
        <div className='KartelaKlientit__Container'>
            {
                openDetails ?
                    <ClientDetails nui={nui} accountID={clientID} accName={accName} />
                    :
                    <div className="KartelaKlientit__Container__FirstDiv">
                        <div className='KartelaKlientit__Container__FirstDiv__Input'>
                            <Autocomplete
                                {...defaultPropsClients}
                                id="include-input-in-list"
                                className='KartelaKlientit__Container__FirstDiv__Input__AutoComplete'
                                includeInputInList
                                value={accField}
                                onChange={handleAutocompleteChangeClient}
                                isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="KartelaKlientit__Container__TextField"
                                        // style={{ width: "55% " }}
                                        label="Kerko Klientin"
                                    />
                                )}
                            />
                        </div>
                        <div className='KartelaKlientit__Container__FirstDiv__Button'>
                            <button className="button-68" variant="contained" onClick={() => showCard()}><FaSearch /> Shfaq Kartelen</button>
                        </div>
                    </div>
            }
            {/* </div> */}
        </div>
    );
};
